/**
 *
 * @param name
 * @returns
 */
export const requireField = <T = string>(
	name: string
): ((value: T) => string | null) => {
	/**
	 * @function reqField
	 * @param {T} value
	 */
	const reqField = (value: T): string | null => {
		if (!value) return `${name} is a required field`;

		return null;
	};

	return reqField;
};
